export interface Setting {
    key: string;
    value: string | number;
}

export namespace Setting {
    export enum settingsKeys {
        app_name = "app_name",
        company_name = "company_name",
        default_theme = "default_theme",
        mail_default_reply_address = "mail_default_reply_address",
        mail_default_domain = "mail_default_domain",
        mail_default_sender = "mail_default_sender",
        mail_default_sender_name = "mail_default_sender_name",
        mail_show_logo_in_signature = "mail_show_logo_in_signature",
        mail_template = "mail_template",
        mail_bon_de_passage_template = "mail_bon_de_passage_template",
        mail_signalement_template = "mail_signalement_template",
        mail_absence_notif_template = "mail_absence_notif_template",
        mail_conges_notif_template = "mail_conges_notif_template",
        mail_demande_double_subject = "mail_demande_double_subject",
        mail_demande_double_template = "mail_demande_double_template",
        cles_pret_alerte_jours = "cles_pret_alerte_jours",
        taux_frais_km = "taux_frais_km",
        geoloc_max_distance = "geoloc_max_distance",
        journee_de_solidarite = "journee_de_solidarite",
        import_excel_bulletin_salaire_first_row = "import_excel_bulletin_salaire_first_row",
        import_excel_bulletin_salaire_employe_column = "import_excel_bulletin_salaire_employe_column",
        import_excel_bulletin_salaire_brut_column = "import_excel_bulletin_salaire_brut_column",
        import_excel_bulletin_salaire_cout_column = "import_excel_bulletin_salaire_cout_column",
        import_excel_bulletin_de_salaire_ignore_row = "import_excel_bulletin_de_salaire_ignore_row",
        token_cost = "token_cost",
        bulletin_salaire_max_pages = "bulletin_salaire_max_pages",
        ai_daily_token_limit = "ai_daily_token_limit",
        bulletin_salaire_prompt = "bulletin_salaire_prompt",
    }
}
